import React from 'react';
import InputRadio from '../InputRadio/InputRadio';
import Tooltip from '../Tooltip/Tooltip';
import parse from 'html-react-parser';
function FormInputRadio({
  register,
  label,
  fieldName,
  handleChange,
  ariaLabel,
  id,
  loading,
  errorMessage,
  labelClasses,
  answerOption,
  isVerticalAlign,
  required,
  tooltip,
  value,
  isChild,
  classLabel,
  classQuestion,
  testId,
  standardQuestionName,
  disabledTip,
}) {
  return (
    <>
      <div className={labelClasses + (classLabel ? ` ${classLabel}` : '')}>
        {tooltip ? (
          // <span style={{ display: 'flex' }}>
          <span>
            {parse(label)} <Tooltip text={tooltip} />
          </span>
        ) : (
           <div dangerouslySetInnerHTML={{ __html: label }} />
          

        )}
      </div>
      <div
        className={
          isChild
            ? 'flex flex-row items-center mb-4'
            : 'flex flex-row items-center horizontal-radio' +
              (classQuestion ? ` ${classQuestion}` : '')
        }
        aria-label={ariaLabel}
        role='application'
        title={disabledTip}
      >
        <InputRadio
          id={id}
          register={
            required
              ? { ...register(fieldName, { required: 'required' }) }
              : { ...register(fieldName) }
          }
          required={required}
          value={value}
          handleChange={handleChange}
          errorMessage={errorMessage}
          answerOption={answerOption}
          disabled={loading}
          isVerticalAlign={isVerticalAlign}
          testId={testId}
          standardQuestionName={standardQuestionName}
        />
      </div>
    </>
  );
}

export default React.memo(FormInputRadio);
